module.exports = __webpack_public_path__ + "static/media/logoald.bc504df6.png";